import React from "react";
import Fade from "react-reveal/Fade";

import Carousel from "../../components/Carousel/Carousel.component";



const Event = ({ workshop }) => {
  const {
    title,
    details = "",
    images = [],
    dateTime,
    venue,
    category,
  } = workshop;

  const isDSP =
    workshop.code === "dsp" &&
    title === "Distinguished Speaker Program";

  // -----------------------------
  // DSP DATA
  // -----------------------------

  const getSpeaker = () => {
    const match = details.match(
      /🎙️\s*Speaker:\s*(.*?)(?:\n|$)/
    );

    return match ? match[1].trim() : "";
  };

  const getGain = () => {
    const match = details.match(
      /💡\s*What you'll gain:\s*(.*?)(?:\n|$)/
    );

    return match ? match[1].trim() : "";
  };

  const speaker = getSpeaker();
  const gain = getGain();

  // -----------------------------
  // NORMAL EVENT DESCRIPTION
  // -----------------------------

  const cleanDescription = details
    .replace(/🎙️\s*Speaker:.*?(?:\n|$)/, "")
    .replace(/💡\s*What you'll gain:.*?(?:\n|$)/, "")
    .replace(/🧠\s*ACM Society presents:.*?(?:\n|$)/, "")
    .trim();

  return (
    <>
      {/* EVENT TITLE ABOVE CARD */}
      <div className="event-title-section">
        <h2>
          {isDSP ? "There is No I in AI" : title}
        </h2>

        <div className="event-title-line"></div>
      </div>

      {/* EVENT CARD */}
      <div className="workshop-container">

        {/* POSTER */}
        <div className="event-poster">
          <Fade bottom delay={100}>
            <div className="poster-wrapper">
              <Carousel images={images} />
            </div>
          </Fade>
        </div>

        {/* EVENT INFORMATION */}
        <div className="info">

          {/* ================= DSP ================= */}
          {isDSP ? (
            <>
              <Fade bottom delay={200}>
                <div className="dsp-content">

                  <div className="event-badge">
                    ACM SOCIETY PRESENTS
                  </div>

                  <h3>There is No I in AI</h3>

                  {speaker && (
                    <div className="structured-details">

                      <div className="detail-row">
                        <div className="detail-icon">
                          🎙️
                        </div>

                        <div className="detail-content">
                          <span className="detail-label">
                            Speaker
                          </span>

                          <p>{speaker}</p>
                        </div>
                      </div>

                      {dateTime && (
                        <div className="detail-row">
                          <div className="detail-icon">
                            📅
                          </div>

                          <div className="detail-content">
                            <span className="detail-label">
                              Date & Time
                            </span>

                            <p>{dateTime}</p>
                          </div>
                        </div>
                      )}

                      {gain && (
                        <div className="detail-row">
                          <div className="detail-icon">
                            💡
                          </div>

                          <div className="detail-content">
                            <span className="detail-label">
                              What you'll gain
                            </span>

                            <p>{gain}</p>
                          </div>
                        </div>
                      )}

                    </div>
                  )}

                </div>
              </Fade>
            </>
          ) : (

            /* ================= NORMAL EVENT ================= */

            <>
              <Fade bottom delay={200}>
                <div className="event-description-wrapper">
                  <p className="event-description">
                    {cleanDescription}
                  </p>
                </div>
              </Fade>

              {/* EVENT META */}
              {(dateTime || venue || category) && (
                <Fade bottom delay={300}>
                  <div className="event-meta">

                    {dateTime && (
                      <div className="meta-item">
                        <div className="meta-icon">
                          📅
                        </div>

                        <div className="meta-content">
                          <span>Date & Time</span>
                          <p>{dateTime}</p>
                        </div>
                      </div>
                    )}

                    {venue && (
                      <div className="meta-item">
                        <div className="meta-icon">
                          📍
                        </div>

                        <div className="meta-content">
                          <span>Venue</span>
                          <p>{venue}</p>
                        </div>
                      </div>
                    )}

                    {category && (
                      <div className="meta-item">
                        <div className="meta-icon">
                          🏷️
                        </div>

                        <div className="meta-content">
                          <span>Category</span>
                          <p>{category}</p>
                        </div>
                      </div>
                    )}

                  </div>
                </Fade>
              )}
            </>
          )}

        </div>
      </div>

      {/* DIVIDER */}
<div className="event-divider-line"></div>
    </>
  );
};

export default Event;